import { Loader2, Save } from 'lucide-react';

type SaveBarProps = {
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
};

export function SaveBar({ isSaving, onCancel, onSave }: SaveBarProps) {
  return (
    <div className="flex items-center justify-end gap-3">
      <button
        type="button"
        onClick={onCancel}
        className="rounded-xl border border-[var(--dash-line)] bg-white px-5 py-2.5 text-sm font-semibold text-[var(--dash-ink)] hover:bg-[var(--dash-soft)]"
      >
        Cancel
      </button>
      <button
        type="button"
        disabled={isSaving}
        onClick={onSave}
        className="inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold text-white shadow-md disabled:opacity-50"
        style={{
          background:
            'linear-gradient(90deg, #8E58A6 0%, #5A4EA6 25%, #145E8C 50%, #007A78 75%, #33A65B 100%)',
        }}
      >
        {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        Save Changes
      </button>
    </div>
  );
}
